import React from 'react';
import { PhoneOff, X } from 'lucide-react';
import { useContact } from '../context/ContactContext';
import { fmtTime } from '../lib/softphoneErrors';

// Incident 2026-09-14 fix 2: a fixed strip across the top of the console that
// appears whenever Streams reports a softphone error (or our own Accept
// fails), so a media failure is no longer invisible. Read-only apart from
// Dismiss; the record is also in sessionStorage (lib/softphoneErrors.js).
export default function SoftphoneBanner() {
  const { softphoneError, clearSoftphoneError } = useContact();
  if (!softphoneError) return null;
  return (
    <div className="softphone-banner" role="alert">
      <PhoneOff size={14} />
      <div className="softphone-banner-text">
        <strong>Softphone problem</strong> — {softphoneError.friendly}
        <span className="softphone-banner-meta">
          {softphoneError.type}{softphoneError.detail ? ` · ${softphoneError.detail}` : ''} · {fmtTime(softphoneError.at)}
        </span>
      </div>
      <button className="softphone-banner-dismiss" onClick={clearSoftphoneError} title="Dismiss">
        <X size={13} />
      </button>
    </div>
  );
}
